export default function IconLinkedin() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.97414 7.32306C8.97414 4.69806 14.66 4.26056 14.66 8.19806V14.4981H11.7733V10.9981C11.7733 10.1231 10.9861 9.42305 10.1113 9.59805C9.41152 9.68555 8.88667 10.3856 8.88667 11.0856V14.4981H6V5.31056H8.88667V7.32306" stroke="currentColor" strokeMiterlimit="10" />
      <path d="M2.25 4C3.2165 4 4 3.2165 4 2.25C4 1.2835 3.2165 0.5 2.25 0.5C1.2835 0.5 0.5 1.2835 0.5 2.25C0.5 3.2165 1.2835 4 2.25 4Z" stroke="currentColor" strokeMiterlimit="10" />
      <path d="M3.73613 5.3125H0.848633V14.4125H3.73613V5.3125Z" stroke="currentColor" strokeMiterlimit="10" />
    </svg>
  );
}
